document.addEventListener('DOMContentLoaded', function() {

    gsap.registerPlugin(ScrollTrigger);
    
    const header = document.querySelector('.header');
    const headerContainer = header.querySelector('.container');
    const headerTitle = header.querySelector('h1');
    

    gsap.set(header, {
        backgroundColor: 'transparent',
        paddingTop: '20px',
        paddingBottom: '20px'
    });
    
    
    const headerTl = gsap.timeline({
        scrollTrigger: {
            trigger: "body",
            start: "top -80px", 
            end: "top -50px",  
            scrub: 1, 
            toggleActions: "play none reverse none"
        }
    });
    
    headerTl
        .to(header, {
            backgroundColor: 'rgba(255, 255, 255, 0.95)', 
            backdropFilter: 'blur(10px)', 
            // boxShadow: '0 2px 20px rgba(0, 0, 0, 0.1)',
            paddingTop: '10px',
            paddingBottom: '10px',
            duration: 0.3
        })
        .to(headerTitle, {
            fontSize: '1.8rem', 
            duration: 0.3
        }, 0) 
        .to(headerContainer, {
            maxHeight: '60px', 
            duration: 0.3
        }, 0);
    
   
});